/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Error_Excerpt_Publish1Inputs */

const vi_cmspost_error_excerpt_publish1 = /** @type {(inputs: Cmspost_Error_Excerpt_Publish1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập mô tả ngắn trước khi đăng bài.`)
};

/**

* @param {Cmspost_Error_Excerpt_Publish1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_excerpt_publish1 = /** @type {((inputs?: Cmspost_Error_Excerpt_Publish1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Excerpt_Publish1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_excerpt_publish1(inputs)
});
export { cmspost_error_excerpt_publish1 as "cmsPost_error_excerpt_publish" }